import { useTranslation } from "../../i18n/useTranslation";
import styles from './fixcenter-career-job-offers.module.scss';
import globalStyles from '../../global-styles.module.scss';
import classNames from 'classnames';

const CareerAccountManagerJobOffer: React.FC = () => {
    const { t } = useTranslation('translation');
    const getTranslate = (code: string) => {
        return t('CAREER_ITEMS.' + code);
    }
    return (
        <>
            <div className={styles.job_offers_container}>
                <div className={styles.content}>
                    <section className={globalStyles.flex_center_item}>
                        <div>
                            <label
                                dangerouslySetInnerHTML={{__html: getTranslate('HEADER_37')}}
                                className={classNames(globalStyles.flex_center_item, styles.h1)}>
                            </label>
                            <label
                                dangerouslySetInnerHTML={{__html: getTranslate('HEADER_38')}}
                                className={classNames(globalStyles.flex_center_item, styles.h1)}>
                            </label>
                            <label
                                dangerouslySetInnerHTML={{__html: getTranslate('HEADER_39')}}
                                className={classNames(globalStyles.flex_center_item, globalStyles.mb_5, styles.h1)}>
                            </label>
                        </div>
                    </section>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_40')}}
                        className={classNames(globalStyles.float_left_item, styles.h2, globalStyles.mb_5)}>
                    </label>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_41')}}
                        className={classNames(globalStyles.float_left_item, styles.h1, globalStyles.underline_text, globalStyles.mb_5)}>
                    </label>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_42')}}
                        className={classNames(globalStyles.float_left_item, styles.h2, globalStyles.mb_2)}>
                    </label>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_43')}}
                        className={classNames(globalStyles.float_left_item, styles.h2, globalStyles.mb_1)}>
                    </label>
                    <ul className={globalStyles.mb_1}>
                        <li><span className={styles.h2}>{getTranslate('LI_54')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_55')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_56')}</span></li>
                    </ul>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_44')}}
                        className={classNames(globalStyles.float_left_item, styles.h2, globalStyles.mb_1)}>
                    </label>
                    <ul className={globalStyles.mb_5}>
                        <li><span className={styles.h2}>{getTranslate('LI_57')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_58')}</span></li>
                    </ul>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_45')}}
                        className={classNames(globalStyles.float_left_item, styles.h1, globalStyles.underline_text, globalStyles.mb_5)}>
                    </label>
                    <ul className={globalStyles.mb_2}>
                        <li><span className={styles.h2}>{getTranslate('LI_59')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_60')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_61')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_62')}</span></li>
                        <li><span className={styles.h2}>{getTranslate('LI_63')}</span></li>
                    </ul>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_46')}}
                        className={classNames(globalStyles.float_left_item, styles.h2, globalStyles.mb_1)}>
                    </label>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_47')}}
                        className={classNames(globalStyles.float_left_item, styles.h2, globalStyles.mb_1)}>
                    </label>
                    <label
                        dangerouslySetInnerHTML={{__html: getTranslate('HEADER_48')}}
                        className={classNames(globalStyles.float_left_item, styles.h2, globalStyles.mb_1)}>
                    </label>
                </div>
            </div>
        </>
    );
};

export default CareerAccountManagerJobOffer;